import React from 'react';
import ActionsProvider from '../ShoppingBundleProvider/ActionsProvider';
import ShoppingCartRequestCreatorProvider from './ShoppingCartRequestCreatorProvider';
import { CreateShoppingBundleProviderWrapper } from 'clientState/providers/CreateShoppingBundleProvider';

export const ShoppingBundleProvider = ({ actions, children }) => (
  <ShoppingCartRequestCreatorProvider>
    <CreateShoppingBundleProviderWrapper>
      <ActionsProvider actions={actions}>{children}</ActionsProvider>
    </CreateShoppingBundleProviderWrapper>
  </ShoppingCartRequestCreatorProvider>
);
